import { DECIMAL_PLACES, MILLISECONDS_IN_A_SECOND } from 'App/constants';

export const flattenObject = (obj, parentKey = '', result = {}) => {
    for (let key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

        let propName = parentKey ? parentKey + '-' + key : key;

        // If the property is an object, recurse
        if (
            typeof obj[key] === 'object' &&
            obj[key] !== null &&
            !Array.isArray(obj[key])
        ) {
            flattenObject(obj[key], propName, result);
        } else {
            // Check if the value is falsy and skip it if it is
            if (obj[key]) {
                result[propName] = obj[key];
            }
        }
    }
    return result;
};

export const getRandomElement = (max, prev) => {
    const newNum = Math.floor(Math.random() * max);

    return newNum === prev ? getRandomElement(max, prev) : newNum;
};

export const arrayFromNumber = (number) => {
    return Array.from({ length: +number }, (_, i) => i + 1);
};

export const setBodyOverflow = ({ overflow }) => {
    document.documentElement.style.setProperty('--overflow', overflow);
};

export const getSecondsDifference = (startDate, endDate) => {
    return +(Math.abs(endDate - startDate) / MILLISECONDS_IN_A_SECOND).toFixed(
        DECIMAL_PLACES
    );
};

export const capitalize = (str) => {
    if (typeof str !== 'string' || str.length === 0) return '';

    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const isNonEmptyString = (value) =>
    typeof value === 'string' && value.trim().length > 0;
